import { GlobalConfig } from 'ngx-toastr/toastr/toastr-config';

export default {
  positionClass: 'toast-bottom-center',
  preventDuplicates: true,
  extendedTimeOut: 2500,
  enableHtml: true
} as Partial<GlobalConfig>;